import React from "react";
import { PopoverBody, UncontrolledPopover } from "reactstrap";

import style from "./Helper.module.scss";

const QuantityHelper = ({ children, quantities, name }) => (
  <div id={`quantity-helper-${name}`} className={style.linkHelper}>
    {children}
    <UncontrolledPopover placement="right" target={`quantity-helper-${name}`} trigger="hover">
      <PopoverBody className={style.helper}>
        {quantities.map((item) => (
          <div key={`quantity-${item.date}`}>{`${item.date}: ${item.quantity} (status: ${item.status})`}</div>
        ))}
      </PopoverBody>
    </UncontrolledPopover>
  </div>
);

export default QuantityHelper;
